import { Box, Divider, Stack } from "@mui/material";
import Grid from "@mui/material/Unstable_Grid2";
import ByzMuiSelect from "src/components/core-components/mui/ByzMuiSelect";
import ByzMuiTypography from "src/components/core-components/mui/inputs/ByzMuiTypography";
import { useTranslate } from "src/locales";
import ByzMuiTextField from "src/components/core-components/mui/inputs/ByzMuiTextField";
import ByzTitleAndInputBox from "src/components/core-components/ByzTitleAndInputBox/ByzTitleAndInputBox";
import ByzMuiRadioButton from "src/components/core-components/mui/buttons/ByzMuiRadioButton";
import { ByzMuiDateTimePicker } from "src/components/core-components/mui/inputs/ByzMuiDateTimePicker";
import ByzMuiButton from "src/components/core-components/mui/buttons/ByzMuiButton";
import { useState } from "react";

function PageFive() {
  const { t } = useTranslate();
  const [apgarScore1, setApgarScore1] = useState(0);
  const [apgarScore5, setApgarScore5] = useState(0);
  const [apgarScore10, setApgarScore10] = useState(0);

  const [appearance1, setAppearance1] = useState("");
  const [pulse1, setPulse1] = useState("");
  const [grimace1, setGrimace1] = useState("");
  const [activity1, setActivity1] = useState("");
  const [respiratory1, setRespiratory1] = useState("");

  const [appearance5, setAppearance5] = useState("");
  const [pulse5, setPulse5] = useState("");
  const [grimace5, setGrimace5] = useState("");
  const [activity5, setActivity5] = useState("");
  const [respiratory5, setRespiratory5] = useState("");

  const [appearance10, setAppearance10] = useState("");
  const [pulse10, setPulse10] = useState("");
  const [grimace10, setGrimace10] = useState("");
  const [activity10, setActivity10] = useState("");
  const [respiratory10, setRespiratory10] = useState("");

  const birthTypeOptions = [
    { value: "1", label: "Normal Doğum" },
    { value: "2", label: "Sezaryen Müdahaleli Doğum" },
    { value: "3", label: "Vakum/Forseps Müdahaleli Doğum" },
    { value: "4", label: "Acil Sectio(Sadece Hasta Nakil Paketinde Kullanılacak)" },
    { value: "5", label: "Elektif Sectio(Sadece Hasta Nakil Paketinde Kullanılacak)" }
  ];

  const genderOptions = [
    { value: "1", label: "Kız" },
    { value: "2", label: "Erkek" }
  ];

  const anesthesiaOptions = [
    { value: "1", label: "Genel Anestezi" },
    { value: "2", label: "Lokal Anestezi" },
    { value: "3", label: "Epidural Anestezi" },
    { value: "4", label: "Lokal Anestezi Sedasyon" },
    { value: "5", label: "Sedasyon Analjesi" },
    { value: "6", label: "Epidural+Spinal Kombine" },
    { value: "7", label: "Maske İle Genel Anestezi" },
    { value: "8", label: "Rejinol(Bölge) Anestezi" },
    { value: "9", label: "Santral Sinir Bloğu" },
    { value: "10", label: "Spinal Anestezi" },
    { value: "11", label: "Periferik Sinir Blok" },
    { value: "12", label: "Axiller Blok" },
    { value: "13", label: "İnterskala Blok" },
    { value: "14", label: "Femoral Blok" },
    { value: "15", label: "Siyatik Blok" },
    { value: "16", label: "Poplital Blok" },
    { value: "17", label: "Sedoaneljezi Anestezi" },
    { value: "18", label: "Epidural-Spinal Anestezi" }
  ];

  const interventionOptions = [
    { value: "1", label: "Hayır" },
    { value: "2", label: "Entübasyon" },
    { value: "3", label: "Serbest Oksijen" },
    { value: "4", label: "Diğer" }
  ];

  const feedingTypeOptions = [
    { value: "1", label: "Anne sütü-Formül Mama" },
    { value: "2", label: "TPN" },
    { value: "3", label: "Sadece Anne Sütü" },
    { value: "4", label: "Sadece Mama" },
    { value: "5", label: "Diyet" },
    { value: "6", label: "Diğer" }
  ];

  const feedingMethodOptions = [
    { value: "1", label: "Oral-Ogs" },
    { value: "2", label: "Ors" },
    { value: "3", label: "Jejunostomi" },
    { value: "4", label: "PEG" },
    { value: "5", label: "Gastrostomi" },
    { value: "6", label: "Diğer" }
  ];

  const colostrumOptions = [
    { value: "1", label: "Oral Kolostrum" },
    { value: "2", label: "Kolostrumla Ağız Bakım" }
  ];

  const appearanceOptions1 = [
    { value: "0", label: "Mor/Soluk" },
    { value: "1", label: "Gövde Pembe/Extremiteler Mor" },
    { value: "2", label: "Tamamen Pembe" }
  ];
  const appearanceOptions5 = [
    { value: "0", label: "Mor/Soluk" },
    { value: "1", label: "Gövde Pembe/Extremiteler Mor" },
    { value: "2", label: "Tamamen Pembe" }
  ];
  const appearanceOptions10 = [
    { value: "0", label: "Mor/Soluk" },
    { value: "1", label: "Gövde Pembe/Extremiteler Mor" },
    { value: "2", label: "Tamamen Pembe" }
  ];

  const pulseOptions = [
    { value: "0", label: "Yok" },
    { value: "1", label: "<100" },
    { value: "2", label: ">100" }
  ];

  const grimaceOptions = [
    { value: "0", label: "Yok" },
    { value: "1", label: "Yüz Buruşturma" },
    { value: "2", label: "Öksürük-Hapşırık-Güçlü Ağlama" }
  ];

  const activityOptions = [
    { value: "0", label: "Yok/Gevşek" },
    { value: "1", label: "Kollar ve bacaklar bükülü" },
    { value: "2", label: "Aktif Hareketli" }
  ];

  const respiratoryOptions = [
    { value: "0", label: "Yok" },
    { value: "1", label: "Düzensiz Çene Atma" },
    { value: "2", label: "Düzenli Ağlama" }
  ];

  const respiratoryFeatureOptions = [
    { value: "1", label: "Normal" },
    { value: "2", label: "İnleme" },
    { value: "3", label: "Solunum Sesleri Eşit" },
    { value: "4", label: "Burnu Kanadı Sol" },
    { value: "5", label: "Apne" },
    { value: "6", label: "Solunum Sesleri" },
    { value: "7", label: "Kaba" },
    { value: "8", label: "Abdominal" },
    { value: "9", label: "Çekilme" },
    { value: "10", label: "Yüzeysel" },
    { value: "11", label: "Taşipne" },
    { value: "12", label: "Siyanoz" }
  ];

  const secretionOptions = [
    { value: "1", label: "Yok" },
    { value: "2", label: "Var" },
    { value: "3", label: "Solunum Sayısı" }
  ];

  const extremitiesOptions = [
    { value: "1", label: "Normal" },
    { value: "2", label: "Ödemli" },
    { value: "3", label: "Ekimoz" }
  ];

  const evacuationMethodOptions = [
    { value: "1", label: "Beze" },
    { value: "2", label: "İdrar katater ile" },
    { value: "3", label: "Masajla" },
    { value: "4", label: "Ostomi" }
  ];

  const abdomenExamOptions = [
    { value: "1", label: "Sert/Hassas" },
    { value: "2", label: "Yumuşak/Rahat" }
  ];

  const defecationProbOptions = [
    { value: "1", label: "Konstipasyon" },
    { value: "2", label: "Diare" },
    { value: "3", label: "Melana" },
    { value: "4", label: "Uyarı ile yapıyor" }
  ];

  const diuresisProbOptions = [
    { value: "1", label: "Yok" },
    { value: "2", label: "Anüri" },
    { value: "3", label: "Poliüri" }
  ];

  const genitalOrgansOptions = [
    { value: "1", label: "Görünüm" },
    { value: "2", label: "Normal" },
    { value: "3", label: "Hipospadias" },
    { value: "4", label: "Epispadias" }
  ];

  const calculateApgarScore1 = () => {
    let score = 0;
    if (appearance1) score += parseInt(appearance1);
    if (pulse1) score += parseInt(pulse1);
    if (grimace1) score += parseInt(grimace1);
    if (activity1) score += parseInt(activity1);
    if (respiratory1) score += parseInt(respiratory1);
    setApgarScore1(score);
  };

  const calculateApgarScore5 = () => {
    let score = 0;
    if (appearance5) score += parseInt(appearance5);
    if (pulse5) score += parseInt(pulse5);
    if (grimace5) score += parseInt(grimace5);
    if (activity5) score += parseInt(activity5);
    if (respiratory5) score += parseInt(respiratory5);
    setApgarScore5(score);
  };

  const calculateApgarScore10 = () => {
    let score = 0;
    if (appearance10) score += parseInt(appearance10);
    if (pulse10) score += parseInt(pulse10);
    if (grimace10) score += parseInt(grimace10);
    if (activity10) score += parseInt(activity10);
    if (respiratory10) score += parseInt(respiratory10);
    setApgarScore10(score);
  };

  return (
    <>
      <Box p={2}>
        <Grid container spacing={2} sx={{ padding: "0px" }}>
          <Box
            sx={{
              border: "1px solid #DBDBDB",
              borderRadius: "4px",
              padding: "20px",
              width: "100%",
            }}
          >
            <Grid
              sx={{
                backgroundColor: "#63B4FF33",
                color: "#2979C3",
                borderRadius: "10px",
              }}
            >
              <ByzMuiTypography isTitle paddingTop={"5px"}>
                {t("newborn-patient-assessment.birth-information")}
              </ByzMuiTypography>
            </Grid>

            <Grid container spacing={2} pt={2}>
              <Grid md={3} xs={12}>
                <ByzTitleAndInputBox marginLeft="0px"
                  title={t("newborn-patient-assessment.rh-incompatibility")}
                >
                  <ByzMuiRadioButton
                    typographyText="yes,no,unknown"
                    layout="row"
                    border="none"
                    fontSize={14}
                    
                    sx={{
                      margin: '0'
                    }}
                  />
                </ByzTitleAndInputBox>
              </Grid>

              <Grid md={2} xs={12}>
                <ByzTitleAndInputBox marginLeft="0px"
                  title={t("newborn-patient-assessment.birth-type")}
                >
                  <ByzMuiSelect
                    renderInput={(params) => (
                      <ByzMuiTextField {...params} />
                    )}
                    options={birthTypeOptions}
                    label="label"
                    placeholder={t(
                      "open-process-menu.select"
                    )}
                    multiple={false}
                    sx={{ pt: 1 }}
                  />
                </ByzTitleAndInputBox>
              </Grid>

              <Grid md={2} xs={12}>
                <ByzTitleAndInputBox marginLeft="0px"
                  title={t("newborn-patient-assessment.birth-date")}
                >
                  <ByzMuiDateTimePicker
                    sx={{ width: "100%", pt: 1 }}
                  />
                </ByzTitleAndInputBox>
              </Grid>

              <Grid md={2} xs={12}>
                <ByzTitleAndInputBox marginLeft="0px"
                  title={t("newborn-patient-assessment.gender")}
                >
                  <ByzMuiSelect
                    renderInput={(params) => (
                      <ByzMuiTextField {...params} />
                    )}
                    options={genderOptions}
                    label="label"
                    placeholder={t(
                      "open-process-menu.select"
                    )}
                    multiple={false}
                    sx={{ pt: 1 }}
                  />
                </ByzTitleAndInputBox>
              </Grid> 

              <Grid md={2} xs={12}>
                <ByzTitleAndInputBox marginLeft="0px"
                  title={t("newborn-patient-assessment.gestational-age")}
                >
                  <ByzMuiTextField
                    type="number"
                    sx={{ pt: 1 }}
                  />
                </ByzTitleAndInputBox>
              </Grid>
            
            
            </Grid>
            <Divider
              sx={{
                borderColor: "black",
                borderBottomWidth: "2px",
                my: 2,
              }}
            />
            <Grid container spacing={2} pt={2}>
              <Grid md={3} xs={12}>
                <ByzTitleAndInputBox marginLeft="0px"
                  title={t("newborn-patient-assessment.breech-presentation")}
                >
                  <ByzMuiRadioButton
                    typographyText="yes,no,unknown"
                    layout="row"
                    border="none"
                    fontSize={14}
                  />
                </ByzTitleAndInputBox>
              </Grid>

              <Grid md={3} xs={12}>
                <ByzTitleAndInputBox marginLeft="0px"
                  title={t("newborn-patient-assessment.cord-entanglement")}
                >
                  <ByzMuiRadioButton
                    typographyText="yes,no,unknown"
                    layout="row"
                    border="none"
                    fontSize={14}
                  />
                </ByzTitleAndInputBox>
              </Grid>
            
              <Grid md={2} xs={12}>
                <ByzTitleAndInputBox marginLeft="0px"
                  title={t("newborn-patient-assessment.anesthesia")}
                >
                  <ByzMuiSelect
                    renderInput={(params) => (
                      <ByzMuiTextField {...params} />
                    )}
                    options={anesthesiaOptions}
                    label="label"
                    placeholder={t(
                      "open-process-menu.select"
                    )}
                    multiple={false}
                    sx={{ pt: 1 }}
                  />
                </ByzTitleAndInputBox>
              </Grid>
            
              <Grid md={2} xs={12}>
                <ByzTitleAndInputBox marginLeft="0px"
                  title={t("newborn-patient-assessment.height")}
                >
                  <ByzMuiTextField
                    type="number"
                    sx={{ pt: 1 }}
                  />
                </ByzTitleAndInputBox>
              </Grid>

              <Grid md={2} xs={12}>
                <ByzTitleAndInputBox marginLeft="0px"
                  title={t("newborn-patient-assessment.head-circumference")}
                >
                  <ByzMuiTextField
                    type="number"
                    sx={{ pt: 1 }}
                  />
                </ByzTitleAndInputBox>
              </Grid>
            </Grid>
            <Divider
              sx={{
                borderColor: "black",
                borderBottomWidth: "2px",
                my: 2,
              }}
            />
            <Grid container spacing={2} pt={2}>
              <Grid md={2} xs={12}>
                <ByzTitleAndInputBox marginLeft="0px"
                  title={t("newborn-patient-assessment.chest-circumference")}
                >
                  <ByzMuiTextField
                    type="number"
                    sx={{ pt: 1 }}
                  />
                </ByzTitleAndInputBox>
              </Grid>
              <Grid md={2} xs={12}>
                <ByzTitleAndInputBox marginLeft="0px"
                  title={t("newborn-patient-assessment.direct-coombs")}
                >
                  <ByzMuiTextField
                    sx={{ pt: 1 }}
                  />
                </ByzTitleAndInputBox>
              </Grid>
              <Grid md={2} xs={12}>
                <ByzTitleAndInputBox marginLeft="0px"
                  title={t("newborn-patient-assessment.birth-weight-day1")}
                >
                  <ByzMuiTextField
                    type="number"
                    sx={{ pt: 1 }}
                  />
                </ByzTitleAndInputBox>
              </Grid>

              <Grid md={2} xs={12}>
                <ByzTitleAndInputBox marginLeft="0px"
                  title={t("newborn-patient-assessment.birth-weight-day2")}
                >
                  <ByzMuiTextField
                    type="number"
                    sx={{ pt: 1 }}
                  />
                </ByzTitleAndInputBox>
              </Grid>

              <Grid md={3} xs={12}>
                <ByzTitleAndInputBox marginLeft="0px"
                  title={t("newborn-patient-assessment.mother-age-at-birth")}
                >
                  <ByzMuiTextField
                    type="number"
                    sx={{ pt: 1 }}
                  />
                </ByzTitleAndInputBox>
              </Grid>
            </Grid>


            <Divider
              sx={{
                borderColor: "black",
                borderBottomWidth: "2px",
                my: 2,
              }}
            />


            <Grid container spacing={2} pt={2}>
              <Grid md={2} xs={12}>
                <ByzTitleAndInputBox marginLeft="0px"
                  title={t("newborn-patient-assessment.baby-intervention")}
                >
                  <ByzMuiSelect
                    renderInput={(params) => (
                      <ByzMuiTextField {...params} />
                    )}
                    options={interventionOptions}
                    label="label"
                    placeholder={t(
                      "open-process-menu.select"
                    )}
                    sx={{ pt: 1 }}
                    multiple={false}
                  />

                  
                </ByzTitleAndInputBox>
              </Grid>

              <Grid md={2} xs={12}>
                <ByzTitleAndInputBox marginLeft="0px"
                  title={t("newborn-patient-assessment.feeding-type")}
                >
                  <ByzMuiSelect
                    renderInput={(params) => (
                      <ByzMuiTextField {...params} />
                    )}
                    options={feedingTypeOptions}
                    label="label"
                    placeholder={t(
                      "open-process-menu.select"
                    )}
                    multiple={false}
                    sx={{ pt: 1 }}
                  />
                </ByzTitleAndInputBox>
              </Grid>

              <Grid md={2} xs={12}>
                <ByzTitleAndInputBox marginLeft="0px"
                  title={t("newborn-patient-assessment.feeding-method")}
                >
                  <ByzMuiSelect
                    renderInput={(params) => (
                      <ByzMuiTextField {...params} />
                    )}
                    options={feedingMethodOptions}
                    label="label"
                    placeholder={t(
                      "open-process-menu.select"
                    )}
                    multiple={false}
                    sx={{ pt: 1 }}
                  />
                </ByzTitleAndInputBox>
              </Grid>

              <Grid md={2} xs={12}>
                <ByzTitleAndInputBox marginLeft="0px"
                  title={t("newborn-patient-assessment.first-6h-colostrum")}
                >
                  <ByzMuiSelect
                    renderInput={(params) => (
                      <ByzMuiTextField {...params} />
                    )}
                    options={colostrumOptions}
                    label="label"
                    placeholder={t(
                      "open-process-menu.select"
                    )}
                    multiple={false}
                    sx={{ pt: 1 }}
                  />
                </ByzTitleAndInputBox>
              </Grid>

              <Grid md={2} xs={12}>
                <ByzTitleAndInputBox marginLeft="0px"
                  title={t("newborn-patient-assessment.colostrum-date")}
                >
                  <ByzMuiDateTimePicker
                    sx={{ width: "100%", pt: 1 }}
                  />
                </ByzTitleAndInputBox>
              </Grid>
            
              <Grid md={3} xs={12}>
                <ByzTitleAndInputBox marginLeft="0px"
                  title={t("newborn-patient-assessment.intervention-description")}
                >
                  <ByzMuiTextField
                    multiline={true}
                    rows={2}
                    sx={{ pt: 1 }}
                  />
                </ByzTitleAndInputBox>
              </Grid>
            </Grid>


            <Grid container spacing={2} pt={2}>





            </Grid>

            <Divider
              sx={{
                borderColor: "black",
                borderBottomWidth: "2px",
                my: 2,
              }}
            />

            <Grid
              sx={{
                backgroundColor: "#63B4FF33",
                color: "#2979C3",
                borderRadius: "10px",
              }}
            >
              <ByzMuiTypography isTitle paddingTop={"5px"}>
                {t("newborn-patient-assessment.apgar-score")}
              </ByzMuiTypography>
            </Grid>

            {/* 1 Dakika APGAR */}
            <Grid container spacing={2} pt={2}>
              <Grid md={12} xs={12}>
                <ByzMuiTypography variant="subtitle1" sx={{ fontWeight: 'bold' }}>
                  {t("newborn-patient-assessment.apgar-1min")}
                </ByzMuiTypography>
              </Grid>

              <Grid md={2} xs={6}>
                <ByzTitleAndInputBox marginLeft="0px"
                  title={t("newborn-patient-assessment.appearance")}
                >
                  <ByzMuiSelect
                    renderInput={(params) => (
                      <ByzMuiTextField {...params} />
                    )}
                    options={appearanceOptions1}
                    label="label"
                    placeholder={t(
                      "open-process-menu.select"
                    )}
                    multiple={false}
                    sx={{ pt: 1 }}
                    onChange={(e: any) => setAppearance1(e.target.value)}
                  />
                </ByzTitleAndInputBox>
              </Grid>

              <Grid md={2} xs={6}>
                <ByzTitleAndInputBox marginLeft="0px"
                  title={t("newborn-patient-assessment.pulse")}
                >
                  <ByzMuiSelect
                    renderInput={(params) => (
                      <ByzMuiTextField {...params} />
                    )}
                    options={pulseOptions}
                    label="label"
                    placeholder={t(
                      "open-process-menu.select"
                    )}
                    multiple={false}
                    sx={{ pt: 1 }}
                    onChange={(e: any) => setPulse1(e.target.value)}
                  />
                </ByzTitleAndInputBox>
              </Grid>

              <Grid md={2} xs={6}>
                <ByzTitleAndInputBox marginLeft="0px"
                  title={t("newborn-patient-assessment.grimace")}
                >
                  <ByzMuiSelect
                    renderInput={(params) => (
                      <ByzMuiTextField {...params} />
                    )}
                    options={grimaceOptions}
                    label="label"
                    placeholder={t(
                      "open-process-menu.select"
                    )}
                    multiple={false}
                    sx={{ pt: 1 }}
                    onChange={(e: any) => setGrimace1(e.target.value)}
                  />
                </ByzTitleAndInputBox>
              </Grid>

              <Grid md={2} xs={6}>
                <ByzTitleAndInputBox marginLeft="0px"
                  title={t("newborn-patient-assessment.activity")}
                >
                  <ByzMuiSelect
                    renderInput={(params) => (
                      <ByzMuiTextField {...params} />
                    )}
                    options={activityOptions}
                    label="label"
                    placeholder={t(
                      "open-process-menu.select"
                    )}
                    multiple={false}
                    sx={{ pt: 1 }}
                    onChange={(e: any) => setActivity1(e.target.value)}
                  />
                </ByzTitleAndInputBox>
              </Grid>

              <Grid md={2} xs={6}>
                <ByzTitleAndInputBox marginLeft="0px"
                  title={t("newborn-patient-assessment.respiratory")}
                >
                  <ByzMuiSelect
                    renderInput={(params) => (
                      <ByzMuiTextField {...params} />
                    )}
                    options={respiratoryOptions}
                    label="label"
                    placeholder={t(
                      "open-process-menu.select"
                    )}
                    multiple={false}
                    sx={{ pt: 1 }}
                    onChange={(e: any) => setRespiratory1(e.target.value)}
                  />
                </ByzTitleAndInputBox>
              </Grid>

              <Grid md={2} xs={6} container alignItems="center">
                <Grid xs={6}>
                  <ByzMuiButton
                    onClick={calculateApgarScore1}
                    sx={{
                      backgroundColor: "#63B4FF33",
                      color: "#2979C3",
                      border: "1px solid #2979C3",
                      mt: 3
                    }}
                  >
                    {t("newborn-patient-assessment.calculate")}
                  </ByzMuiButton>
                </Grid>
                <Grid xs={6}>
                  <ByzTitleAndInputBox marginLeft="0px"
                    title={t("newborn-patient-assessment.result")}
                  >
                    <ByzMuiTextField
                      value={apgarScore1.toString()}
                      disabled
                      sx={{ mt: 1 }}
                    />
                  </ByzTitleAndInputBox>
                </Grid>
              </Grid>
            </Grid>

            {/* 5 Dakika APGAR */}
            <Grid container spacing={2} pt={2}>
              <Grid md={12} xs={12}>
                <ByzMuiTypography variant="subtitle1" sx={{ fontWeight: 'bold' }}>
                  {t("newborn-patient-assessment.apgar-5min")}
                </ByzMuiTypography>
              </Grid>

              <Grid md={2} xs={6}>
                <ByzTitleAndInputBox marginLeft="0px"
                  title={t("newborn-patient-assessment.appearance")}
                >
                  <ByzMuiSelect
                    renderInput={(params) => (
                      <ByzMuiTextField {...params} />
                    )}
                    options={appearanceOptions5}
                    label={t("open-process-menu.select")}
                    placeholder={t(
                      "open-process-menu.select"
                    )}
                    multiple={false}
                    sx={{ pt: 1 }}
                    onChange={(e: any) => setAppearance5(e.target.value)}
                  />
                </ByzTitleAndInputBox>
              </Grid>

              <Grid md={2} xs={6}>
                <ByzTitleAndInputBox marginLeft="0px"
                  title={t("newborn-patient-assessment.pulse")}
                >
                  <ByzMuiSelect
                    renderInput={(params) => (
                      <ByzMuiTextField {...params} />
                    )}
                    options={pulseOptions}
                    label={t("open-process-menu.select")}
                    placeholder={t(
                      "open-process-menu.select"
                    )}
                    sx={{ pt: 1 }}
                    multiple={false}
                    onChange={(e: any) => setPulse5(e.target.value)}
                  />
                </ByzTitleAndInputBox>
              </Grid>

              <Grid md={2} xs={6}>
                <ByzTitleAndInputBox marginLeft="0px"
                  title={t("newborn-patient-assessment.grimace")}
                >
                  <ByzMuiSelect
                    renderInput={(params) => (
                      <ByzMuiTextField {...params} />
                    )}
                    options={grimaceOptions}
                    label={t("open-process-menu.select")}
                    placeholder={t(
                      "open-process-menu.select"
                    )}
                    sx={{ pt: 1 }}
                    multiple={false}
                    onChange={(e: any) => setGrimace5(e.target.value)}
                  />
                </ByzTitleAndInputBox>
              </Grid>

              <Grid md={2} xs={6}>
                <ByzTitleAndInputBox marginLeft="0px"
                  title={t("newborn-patient-assessment.activity")}
                >
                  <ByzMuiSelect
                    renderInput={(params) => (
                      <ByzMuiTextField {...params} />
                    )}
                    options={activityOptions}
                    label={t("open-process-menu.select")}
                    placeholder={t(
                      "open-process-menu.select"
                    )}
                    sx={{ pt: 1 }}
                    multiple={false}
                    onChange={(e: any) => setActivity5(e.target.value)}
                  />
                </ByzTitleAndInputBox>
              </Grid>

              <Grid md={2} xs={6}>
                <ByzTitleAndInputBox marginLeft="0px"
                  title={t("newborn-patient-assessment.respiratory")}
                >
                  <ByzMuiSelect
                    renderInput={(params) => (
                      <ByzMuiTextField {...params} />
                    )}
                    options={respiratoryOptions}
                    label={t("open-process-menu.select")}
                    placeholder={t(
                      "open-process-menu.select"
                    )}
                    sx={{ pt: 1 }}
                    multiple={false}
                    onChange={(e: any) => setRespiratory5(e.target.value)}
                  />
                </ByzTitleAndInputBox>
              </Grid>

              <Grid md={2} xs={6} container alignItems="center">
                <Grid xs={6}>
                  <ByzMuiButton
                    onClick={calculateApgarScore5}
                    sx={{
                      backgroundColor: "#63B4FF33",
                      color: "#2979C3",
                      border: "1px solid #2979C3",
                      mt: 3
                    }}
                  >
                    {t("newborn-patient-assessment.calculate")}
                  </ByzMuiButton>
                </Grid>
                <Grid xs={6}>
                  <ByzTitleAndInputBox marginLeft="0px"
                    title={t("newborn-patient-assessment.result")}
                  >
                    <ByzMuiTextField
                      value={apgarScore5.toString()}
                      disabled
                      sx={{ mt: 1 }}
                    />
                  </ByzTitleAndInputBox>
                </Grid>
              </Grid>
            </Grid>

            {/* 10 Dakika APGAR */}
            <Grid container spacing={2} pt={2}>
              <Grid md={12} xs={12}>
                <ByzMuiTypography variant="subtitle1" sx={{ fontWeight: 'bold' }}>
                  {t("newborn-patient-assessment.apgar-10min")}
                </ByzMuiTypography>
              </Grid>

              <Grid md={2} xs={6}>
                <ByzTitleAndInputBox marginLeft="0px"
                  title={t("newborn-patient-assessment.appearance")}
                >
                  <ByzMuiSelect
                    renderInput={(params) => (
                      <ByzMuiTextField {...params} />
                    )}
                    options={appearanceOptions10}
                    label={t("open-process-menu.select")}
                    placeholder={t(
                      "open-process-menu.select"
                    )}
                    multiple={false}
                    sx={{ pt: 1 }}
                    onChange={(e: any) => setAppearance10(e.target.value)}
                  />
                </ByzTitleAndInputBox>
              </Grid>

              <Grid md={2} xs={6}>
                <ByzTitleAndInputBox marginLeft="0px"
                  title={t("newborn-patient-assessment.pulse")}
                >
                  <ByzMuiSelect
                    renderInput={(params) => (
                      <ByzMuiTextField {...params} />
                    )}
                    options={pulseOptions}
                    label={t("open-process-menu.select")}
                    placeholder={t(
                      "open-process-menu.select"
                    )}
                    sx={{ pt: 1 }}
                    multiple={false}
                    onChange={(e: any) => setPulse10(e.target.value)}
                  />
                </ByzTitleAndInputBox>
              </Grid>

              <Grid md={2} xs={6}>
                <ByzTitleAndInputBox marginLeft="0px"
                  title={t("newborn-patient-assessment.grimace")}
                >
                  <ByzMuiSelect
                    renderInput={(params) => (
                      <ByzMuiTextField {...params} />
                    )}
                    options={grimaceOptions}
                    label={t("open-process-menu.select")}
                    placeholder={t(
                      "open-process-menu.select"
                    )}
                    sx={{ pt: 1 }}
                    multiple={false}
                    onChange={(e: any) => setGrimace10(e.target.value)}
                  />
                </ByzTitleAndInputBox>
              </Grid>

              <Grid md={2} xs={6}>
                <ByzTitleAndInputBox marginLeft="0px"
                  title={t("newborn-patient-assessment.activity")}
                >
                  <ByzMuiSelect
                    renderInput={(params) => (
                      <ByzMuiTextField {...params} />
                    )}
                    options={activityOptions}
                    label={t("open-process-menu.select")}
                    placeholder={t( 
                      "open-process-menu.select"
                    )}
                    sx={{ pt: 1 }}
                    multiple={false}
                    onChange={(e: any) => setActivity10(e.target.value)}
                  />
                </ByzTitleAndInputBox>
              </Grid>

              <Grid md={2} xs={6}>
                <ByzTitleAndInputBox marginLeft="0px"
                  title={t("newborn-patient-assessment.respiratory")}
                >
                  <ByzMuiSelect
                    renderInput={(params) => (
                      <ByzMuiTextField {...params} />
                    )}
                    options={respiratoryOptions}
                    label={t("open-process-menu.select")}
                    placeholder={t(
                      "open-process-menu.select"
                    )}
                    sx={{ pt: 1 }}
                    multiple={false}
                    onChange={(e: any) => setRespiratory10(e.target.value)}
                  />
                </ByzTitleAndInputBox>
              </Grid>

              <Grid md={2} xs={6} container alignItems="center">
                <Grid xs={6}>
                  <ByzMuiButton
                    onClick={calculateApgarScore10}
                    sx={{
                      backgroundColor: "#63B4FF33",
                      color: "#2979C3",
                      border: "1px solid #2979C3",
                      mt: 3
                    }}
                  >
                    {t("newborn-patient-assessment.calculate")}
                  </ByzMuiButton>
                </Grid>
                <Grid xs={6}>
                  <ByzTitleAndInputBox marginLeft="0px"
                    title={t("newborn-patient-assessment.result")}
                  >
                    <ByzMuiTextField
                      value={apgarScore10.toString()}
                      disabled
                      sx={{ mt: 1 }}
                    />
                  </ByzTitleAndInputBox>
                </Grid>
              </Grid>
            </Grid>

            <Divider
              sx={{
                borderColor: "black",
                borderBottomWidth: "2px",
                my: 2,
              }}
            />

            <Grid
              sx={{
                backgroundColor: "#63B4FF33",
                color: "#2979C3",
                borderRadius: "10px",
              }}
            >
              <ByzMuiTypography isTitle paddingTop={"5px"}>
                {t("newborn-patient-assessment.treatments")}
              </ByzMuiTypography>
            </Grid>

            <Grid container spacing={2} pt={2}>
              <Grid md={12} xs={12}>
                <Stack direction="row" spacing={4}>
                  <ByzMuiRadioButton
                    typographyText="newborn-patient-assessment.in-facility,newborn-patient-assessment.out-facility"
                    layout="row"
                    border="none"
                    fontSize={14}
                  />
                </Stack>
              </Grid>
            </Grid>


            <Grid container spacing={2} pt={2}>
  <Grid md={2} xs={4}>
    <ByzTitleAndInputBox marginLeft="0px"
      title={t("newborn-patient-assessment.vit-k")}
    >
      <ByzMuiRadioButton
        typographyText="newborn-patient-assessment.done,newborn-patient-assessment.not-done"
        layout="row"
        border="none"
        fontSize={14}
      />
    </ByzTitleAndInputBox>
  </Grid>

  <Grid md={2} xs={4}>
    <ByzTitleAndInputBox marginLeft="0px"
      title={t("newborn-patient-assessment.eye-prophylaxis")}
    >
      <ByzMuiRadioButton
        typographyText="newborn-patient-assessment.done,newborn-patient-assessment.not-done"
        layout="row"
        border="none"
        fontSize={14}
      />
    </ByzTitleAndInputBox>
  </Grid>

  <Grid md={3} xs={6}>
    <ByzTitleAndInputBox marginLeft="0px"
      title={t("newborn-patient-assessment.hep-b-vaccine")}
    >
      <ByzMuiRadioButton
        typographyText="newborn-patient-assessment.done,newborn-patient-assessment.not-done"
        layout="row"
        border="none"
        fontSize={14}
      />
    </ByzTitleAndInputBox>
  </Grid>

  <Grid md={3} xs={6}>
    <ByzTitleAndInputBox marginLeft="0px"
      title={t("newborn-patient-assessment.hep-b-ig")}
    >
      <ByzMuiRadioButton
        typographyText="newborn-patient-assessment.done,newborn-patient-assessment.not-done"
        layout="row"
        border="none"
        fontSize={14}
      />
    </ByzTitleAndInputBox>
  </Grid>

  <Grid md={2} xs={4}>
    <ByzTitleAndInputBox marginLeft="0px"
      title={t("newborn-patient-assessment.pku-tsh")}
    >
      <ByzMuiRadioButton
        typographyText="newborn-patient-assessment.done,newborn-patient-assessment.not-done"
        layout="row"
        border="none"
        fontSize={14}
      />
    </ByzTitleAndInputBox>
  </Grid>


</Grid>

{/* Uygulayan/Lot No bölümü */}
<Grid container spacing={2} pt={2}>
  <Grid md={2} xs={4}>
    <ByzTitleAndInputBox marginLeft="0px"
      title={t("newborn-patient-assessment.administrator")}
    >
      <ByzMuiSelect
        renderInput={(params) => (
          <ByzMuiTextField {...params} />
        )}
        options={[]}
        label={t("open-process-menu.select")}
        placeholder={t("open-process-menu.select")}
        sx={{ pt: 1 }}
      />
    </ByzTitleAndInputBox>
  </Grid>

  <Grid md={2} xs={4}>
    <ByzTitleAndInputBox marginLeft="0px"
      title={t("newborn-patient-assessment.administrator")}
    >
      <ByzMuiSelect
        renderInput={(params) => (
          <ByzMuiTextField {...params} />
        )}
        options={[]}
        label={t("open-process-menu.select")}
        placeholder={t("open-process-menu.select")}
        sx={{ pt: 1 }}
      />
    </ByzTitleAndInputBox>
  </Grid>

  <Grid md={3} xs={12} container spacing={1}>
    <Grid md={6} xs={6}>
      <ByzTitleAndInputBox marginLeft="0px"
        title={t("newborn-patient-assessment.administrator")}
      >
        <ByzMuiSelect
          renderInput={(params) => (
            <ByzMuiTextField {...params} />
          )}
          options={[]}
          label={t("open-process-menu.select")}
          placeholder={t("open-process-menu.select")}
          sx={{ pt: 1 }}
        />
      </ByzTitleAndInputBox>
    </Grid>
    <Grid md={6} xs={6}>
      <ByzTitleAndInputBox marginLeft="0px"
        title={t("newborn-patient-assessment.lot-no")}
      >
        <ByzMuiTextField
          sx={{ pt: 1 }}
        />
      </ByzTitleAndInputBox>
    </Grid>
  </Grid>

  <Grid md={3} xs={12} container spacing={1}>
    <Grid md={6} xs={6}>
      <ByzTitleAndInputBox marginLeft="0px"
        title={t("newborn-patient-assessment.administrator")}
      >
        <ByzMuiSelect
          renderInput={(params) => (
            <ByzMuiTextField {...params} />
          )}
          options={[]}
          label={t("open-process-menu.select")}
          placeholder={t("open-process-menu.select")}
          sx={{ pt: 1 }}
        />
      </ByzTitleAndInputBox>
    </Grid>
    <Grid md={6} xs={6}>
      <ByzTitleAndInputBox marginLeft="0px"
        title={t("newborn-patient-assessment.lot-no")}
      >
        <ByzMuiTextField
          sx={{ pt: 1 }}
        />
      </ByzTitleAndInputBox>
    </Grid>
  </Grid>

  <Grid md={2} xs={4}>
    <ByzTitleAndInputBox marginLeft="0px"
      title={t("newborn-patient-assessment.administrator")}
    >
      <ByzMuiSelect
        renderInput={(params) => (
          <ByzMuiTextField {...params} />
        )}
        options={[]}
        label={t("open-process-menu.select")}
        placeholder={t("open-process-menu.select")}
        sx={{ pt: 1 }}
      />
    </ByzTitleAndInputBox>
  </Grid>
</Grid>

<Grid container spacing={2} pt={2}>
  <Grid md={2} xs={4}>
    <ByzTitleAndInputBox marginLeft="0px"
      title={t("newborn-patient-assessment.hematocrit")}
    >
      <ByzMuiRadioButton
        typographyText="newborn-patient-assessment.done,newborn-patient-assessment.not-done"
        layout="row"
        border="none"
        fontSize={14}
      />
    </ByzTitleAndInputBox>
  </Grid>
</Grid>




            <Divider
              sx={{
                borderColor: "black",
                borderBottomWidth: "2px",
                my: 2,
              }}
            />

            <Grid
              sx={{
                backgroundColor: "#63B4FF33",
                color: "#2979C3",
                borderRadius: "10px",
              }}
            >
              <ByzMuiTypography isTitle paddingTop={"5px"}>
                {t("newborn-patient-assessment.hearing-test")}
              </ByzMuiTypography>
            </Grid>

            <Grid container spacing={2} pt={2}>
              <Grid md={2} xs={6}>
                <ByzTitleAndInputBox marginLeft="0px"
                  title={t("newborn-patient-assessment.test-date")}
                >
                  <ByzMuiDateTimePicker
                    sx={{ width: "100%", pt: 1 }}
                  />
                </ByzTitleAndInputBox>
              </Grid>

              <Grid md={2} xs={6}>
                <ByzTitleAndInputBox marginLeft="0px"
                  title={t("newborn-patient-assessment.right-ear")}
                >
                  <ByzMuiRadioButton
                    typographyText="newborn-patient-assessment.pass,newborn-patient-assessment.fail"
                    layout="row"
                    border="none"
                    fontSize={14}
                  />
                </ByzTitleAndInputBox>
              </Grid>

              <Grid md={2} xs={6}>
                <ByzTitleAndInputBox marginLeft="0px"
                  title={t("newborn-patient-assessment.left-ear")}
                >
                  <ByzMuiRadioButton
                    typographyText="newborn-patient-assessment.pass,newborn-patient-assessment.fail"
                    layout="row"
                    border="none"
                    fontSize={14}
                  />
                </ByzTitleAndInputBox>
              </Grid>

              <Grid md={2} xs={6}>
                <ByzTitleAndInputBox marginLeft="0px"
                  title={t("newborn-patient-assessment.control-date")}
                >
                  <ByzMuiDateTimePicker
                    sx={{ width: "100%", pt: 1 }}
                  />
                </ByzTitleAndInputBox>
              </Grid>

              <Grid md={3} xs={6}>
                <ByzTitleAndInputBox marginLeft="0px"
                  title={t("newborn-patient-assessment.result-given-to-family")}
                >
                  <ByzMuiRadioButton
                    typographyText="yes,no,unknown"
                    layout="row"
                    border="none"
                    fontSize={14}
                  />
                </ByzTitleAndInputBox>
              </Grid>
            </Grid>

            <Grid container spacing={2} pt={2}>
              <Grid md={2} xs={6}>
              </Grid>
              <Grid md={2} xs={6}>
              </Grid>
              <Grid md={2} xs={6}>
              </Grid>
              <Grid md={2} xs={6}>
                <ByzTitleAndInputBox marginLeft="0px"
                  title={t("newborn-patient-assessment.administrator")}
                >
                  <ByzMuiTextField
                    sx={{ pt: 1 }}
                  />
                </ByzTitleAndInputBox>
              </Grid>

              <Grid md={3} xs={6}>
                <ByzTitleAndInputBox marginLeft="0px"
                  title={t("newborn-patient-assessment.description")}
                >
                  <ByzMuiTextField
                    multiline={true}
                    rows={2}
                    sx={{ pt: 1 }}
                  />
                </ByzTitleAndInputBox>
              </Grid>
            </Grid>

            <Divider
              sx={{
                borderColor: "black",
                borderBottomWidth: "2px",
                my: 2,
              }}
            />

            <Grid
              sx={{
                backgroundColor: "#63B4FF33",
                color: "#2979C3",
                borderRadius: "10px",
              }}
            >
              <ByzMuiTypography isTitle paddingTop={"5px"}>
                {t("newborn-patient-assessment.respiratory-circulatory")}
              </ByzMuiTypography>
            </Grid>

            <Grid container spacing={2} pt={2}>
              <Grid md={2} xs={12}>
                <ByzTitleAndInputBox marginLeft="0px"
                  title={t("newborn-patient-assessment.respiratory-feature")}
                >
                  <ByzMuiSelect
                    renderInput={(params) => (
                      <ByzMuiTextField {...params} />
                    )}
                    options={respiratoryFeatureOptions}
                    label="label"
                    placeholder={t(
                      "open-process-menu.select"
                    )}
                    sx={{ pt: 1 }}
                    multiple={false}
                  />
                </ByzTitleAndInputBox>
              </Grid>

              <Grid md={2} xs={12}>
                <ByzTitleAndInputBox marginLeft="0px"
                  title={t("newborn-patient-assessment.extremities")}
                >
                  <ByzMuiSelect
                    renderInput={(params) => (
                      <ByzMuiTextField {...params} />
                    )}
                    options={extremitiesOptions}
                    label="label"
                    placeholder={t(
                      "open-process-menu.select"
                    )}
                    multiple={false}
                    sx={{ pt: 1 }}
                  />
                </ByzTitleAndInputBox>
              </Grid>

              <Grid md={2} xs={12}>
                <ByzTitleAndInputBox marginLeft="0px"
                  title={t("newborn-patient-assessment.secretion")}
                >
                  <ByzMuiSelect
                    renderInput={(params) => (
                      <ByzMuiTextField {...params} />
                    )}
                    options={secretionOptions}
                    label="label"
                    placeholder={t(
                      "open-process-menu.select"
                    )}
                    multiple={false}
                    sx={{ pt: 1 }}
                  />
                </ByzTitleAndInputBox>
              </Grid>
              <Grid md={2} xs={12}>
                <ByzTitleAndInputBox marginLeft="0px"
                  title={t("newborn-patient-assessment.oxygen-support")}
                >
                  <ByzMuiRadioButton
                    typographyText="exists,not-exists"
                    layout="row"
                    border="none"
                    fontSize={14}
                  />
                </ByzTitleAndInputBox>
              </Grid>
              <Grid md={2} xs={12}>
                <ByzTitleAndInputBox marginLeft="0px"
                  title={t("newborn-patient-assessment.capillary-filling")}
                >
                  <ByzMuiRadioButton
                    typographyText="newborn-patient-assessment.>3sn,newborn-patient-assessment.<3sn"
                    layout="row"
                    border="none"
                    fontSize={14}
                  />
                </ByzTitleAndInputBox>
              </Grid>

            </Grid>

            <Grid container spacing={2} pt={2}>


              <Grid md={2} xs={6}>
                <ByzTitleAndInputBox marginLeft="0px"
                  title={t("newborn-patient-assessment.murmur")}
                >
                  <ByzMuiRadioButton
                    typographyText="exists,not-exists"
                    layout="row"
                    border="none"
                    fontSize={14}
                  />
                </ByzTitleAndInputBox>
              </Grid>

              <Grid md={2} xs={6}>
                <ByzTitleAndInputBox marginLeft="0px"
                  title={t("newborn-patient-assessment.precordial-beat")}
                >
                  <ByzMuiRadioButton
                    typographyText="exists,not-exists"
                    layout="row"
                    border="none"
                    fontSize={14}
                  />
                </ByzTitleAndInputBox>
              </Grid>

              <Grid md={2} xs={6}>
                <ByzTitleAndInputBox marginLeft="0px"
                  title={t("newborn-patient-assessment.choanal-atresia")}
                >
                  <ByzMuiRadioButton
                    typographyText="exists,not-exists"
                    layout="row"
                    border="none"
                    fontSize={14}
                  />
                </ByzTitleAndInputBox>
              </Grid>

            </Grid>

            <Divider
              sx={{
                borderColor: "black",
                borderBottomWidth: "2px",
                my: 2,
              }}
            />

            <Grid
              sx={{
                backgroundColor: "#63B4FF33",
                color: "#2979C3",
                borderRadius: "10px",
              }}
            >
              <ByzMuiTypography isTitle paddingTop={"5px"}>
                {t("newborn-patient-assessment.elimination")}
              </ByzMuiTypography>
            </Grid>

            <Grid container spacing={2} pt={2}>
              <Grid md={2} xs={6}>
                <ByzTitleAndInputBox marginLeft="0px"
                  title={t("newborn-patient-assessment.evacuation-method")}
                >
                  <ByzMuiSelect
                    renderInput={(params) => (
                      <ByzMuiTextField {...params} />
                    )}
                    options={evacuationMethodOptions}
                    label="label"
                    placeholder={t(
                      "open-process-menu.select"
                    )}
                    multiple={false}
                    sx={{ pt: 1 }}
                  />
                </ByzTitleAndInputBox>
              </Grid>

              <Grid md={2} xs={6}>
                <ByzTitleAndInputBox marginLeft="0px"
                  title={t("newborn-patient-assessment.abdomen-exam")}
                >
                  <ByzMuiSelect
                    renderInput={(params) => (
                      <ByzMuiTextField {...params} />
                    )}
                    options={abdomenExamOptions}
                    label="label"
                    placeholder={t(
                      "open-process-menu.select"
                    )}
                    multiple={false}
                    sx={{ pt: 1 }}
                  />
                </ByzTitleAndInputBox>
              </Grid>

              <Grid md={2} xs={6}>
                <ByzTitleAndInputBox marginLeft="0px"
                  title={t("newborn-patient-assessment.defecation-problem")}
                >
                  <ByzMuiSelect
                    renderInput={(params) => (
                      <ByzMuiTextField {...params} />
                    )}
                    options={defecationProbOptions}
                    label="label"
                    placeholder={t(
                      "open-process-menu.select"
                    )}
                    multiple={false}
                    sx={{ pt: 1 }}
                  />
                </ByzTitleAndInputBox>
              </Grid>

              <Grid md={2} xs={6}>
                <ByzTitleAndInputBox marginLeft="0px"
                  title={t("newborn-patient-assessment.diuresis-problem")}
                >
                  <ByzMuiSelect
                    renderInput={(params) => (
                      <ByzMuiTextField {...params} />
                    )}
                    options={diuresisProbOptions}
                    label="label"
                    placeholder={t(
                      "open-process-menu.select"
                    )}
                    multiple={false}
                    sx={{ pt: 1 }}
                  />
                </ByzTitleAndInputBox>
              </Grid>
              <Grid md={3} xs={6}>
                <ByzTitleAndInputBox marginLeft="0px"
                  title={t("newborn-patient-assessment.meconium")}
                >
                  <ByzMuiRadioButton
                    typographyText="newborn-patient-assessment.done,newborn-patient-assessment.not-done"
                    layout="row"
                    border="none"
                    fontSize={14}
                  />
                </ByzTitleAndInputBox>
              </Grid>
            </Grid>

            <Grid container spacing={2} pt={2}>
              <Grid md={2} xs={6}>
                <ByzTitleAndInputBox marginLeft="0px"
                  title={t("newborn-patient-assessment.urine")}
                >
                  <ByzMuiRadioButton
                    typographyText="newborn-patient-assessment.done,newborn-patient-assessment.not-done"
                    layout="row"
                    border="none"
                    fontSize={14}
                  />
                </ByzTitleAndInputBox>
              </Grid>

              <Grid md={2} xs={6}>
                <ByzTitleAndInputBox marginLeft="0px"
                  title={t("newborn-patient-assessment.anal-atresia")}
                >
                  <ByzMuiRadioButton
                    typographyText="exists,not-exists"
                    layout="row"
                    border="none"
                    fontSize={14}
                  />
                </ByzTitleAndInputBox>
              </Grid>

              <Grid md={2} xs={6}>
                <ByzTitleAndInputBox marginLeft="0px"
                  title={t("newborn-patient-assessment.genital-organs")}
                >
                  <ByzMuiSelect
                    renderInput={(params) => (
                      <ByzMuiTextField {...params} />
                    )}
                    options={genitalOrgansOptions}
                    label="label"
                    placeholder={t(
                      "open-process-menu.select"
                    )}
                    multiple={false}
                    sx={{ pt: 1 }}
                  />
                </ByzTitleAndInputBox>
              </Grid>

              
              <Grid md={2} xs={12}>
                <ByzTitleAndInputBox marginLeft="0px"
                  title={t("newborn-patient-assessment.testicles")}
                >
                  <ByzMuiRadioButton
                    typographyText="newborn-patient-assessment.descended,newborn-patient-assessment.not-descended"
                    layout="row"
                    border="none"
                    fontSize={14}
                  />
                </ByzTitleAndInputBox>
              </Grid>

              <Grid md={2} xs={6}>
                <ByzTitleAndInputBox marginLeft="0px"
                  title={t("newborn-patient-assessment.vaginal-discharge")}
                >
                  <ByzMuiRadioButton
                    typographyText="exists,not-exists"
                    layout="row"
                    border="none"
                    fontSize={14}
                  />
                </ByzTitleAndInputBox>
              </Grid>

            </Grid>

            <Grid container spacing={2} pt={2}>



            </Grid>
          </Box>
        </Grid>
      </Box>
    </>
  );
}

export default PageFive;